import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';

import { colours, scenarios } from './../helpers';
import PieChartComponent from './PieChartComponent';
import CaseAmendingBaselineUpdateContainer from
  './../Containers/CaseAmendingBaselineUpdateContainer';

const pieSlices = scenarios.getPieSlices(scenarios.SCENARIO_IMPORTANCE, colours.colours);

const CaseAmendingPieStatsComponent = ({
  style,
  title,
  pieData,
  jobTypesByName,
  onShowCaseAmendingBaselineUpdateModal,
  visible,
  modalImageName
}) => (
  <div>
    { visible && modalImageName === title &&
      <CaseAmendingBaselineUpdateContainer
        imageName={title} jobTypes={jobTypesByName}
      />}
    <Panel bsStyle={style}>
      <Panel.Heading>
        <Panel.Title>
          <div>
            {title}
          </div>
        </Panel.Title>
      </Panel.Heading>
      <Panel.Body>
        <PieChartComponent height={100} slices={pieSlices} data={pieData} />
      </Panel.Body>
      <Panel.Footer>
        {
          jobTypesByName.length > 0 ?
            <div>
              <a onClick={() => onShowCaseAmendingBaselineUpdateModal(title)}>
                Reset Baseline</a>
            </div> : null
        }
      </Panel.Footer>
    </Panel>
  </div>
);

CaseAmendingPieStatsComponent.propTypes = {
  style: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  pieData: PropTypes.arrayOf(PropTypes.number).isRequired,
  jobTypesByName: PropTypes.array.isRequired,
  onShowCaseAmendingBaselineUpdateModal: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  modalImageName: PropTypes.string.isRequired
};

export default CaseAmendingPieStatsComponent;


// WEBPACK FOOTER //
// src/Components/CaseAmendingPieStatsComponent.jsx